package navigation.home.messages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.features.message.ui.chat.ChatEvent
import com.essntl.features.message.ui.group_info.GroupInfoScreen

class GroupInfoScreenNav(
    private val groupId: String,
) : Screen {

    @Composable
    override fun Content() {

        val chatScreenModel = koinScreenModel<ChatScreenModel>()
        val chatState by chatScreenModel.state.collectAsState()

        LaunchedEffect(Unit) {
            chatScreenModel.onEvent(ChatEvent.GetWhapiGroupById(groupId))
        }

        GroupInfoScreen(
            state = chatState,
            onEvent = chatScreenModel::onEvent,
        )
    }
}